import React, { useCallback } from "react";
import { Input, Radio } from "antd";
import {
    AgentDetailSectionEnum,
    IAgentProductDetails,
} from "../../../../../../../../../../../../agentDetail.model";
import { selectAgentDetailSaving, selectDraftProducts } from "../../../../../../../../../../../../store/agentDetail/agentDetailSelectors";
import { useAgentsStore } from "../../../../../../../../../../../../store/agents.store";
import styles from "./accordionBody.module.css";

const PRODUCT_STATUS_OPTIONS = [
    { label: "Approved", value: "approved" },
    { label: "Not Approved", value: "notApproved" },
];

export const AccordionBody = ({ product }: { product: IAgentProductDetails }) => {
    const products = useAgentsStore(selectDraftProducts);
    const isSaving = useAgentsStore(selectAgentDetailSaving);

    const updateDraftField = useAgentsStore((state) => state.updateDraftField);

    const updateProduct = useCallback((
        patch: Partial<IAgentProductDetails>,
    ) => {
        const nextProducts = products.map((p) => {
            if (p.productUid === product.productUid) {
                return { ...p, ...patch };
            }
            return p;
        });
        updateDraftField(
            AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION,
            'agentProductDetails',
            nextProducts,
        );
    }, [products, product.productUid, updateDraftField]);

    const handleAgencyNumberChange = useCallback((value: string) => {
        const nextValue: string | null = value === '' ? null : value;
        updateProduct({ agencyNumber: nextValue });
    }, [updateProduct]);

    const handleStatusChange = useCallback((isApproved: boolean) => {
        updateProduct({ isApproved });
    }, [updateProduct]);

    return (
        <div className={styles.accordionBody}>
            <div className={styles.rowCtn}>
                <div className={`${styles.rowItem} ${styles.agencyNumberItem}`}>
                    <div className={styles.label}>Agency Number</div>
                    <div className={styles.value}>
                        <Input
                            className={styles.input}
                            value={product.agencyNumber ?? ''}
                            placeholder="Enter Agency Number"
                            allowClear
                            disabled={isSaving}
                            onChange={(e) => handleAgencyNumberChange(e.target.value)}
                        />
                    </div>
                </div>
                <div className={`${styles.rowItem} ${styles.statusItem}`}>
                    <div className={styles.label}>Product Status</div>
                    <div className={styles.value}>
                        <Radio.Group
                            options={PRODUCT_STATUS_OPTIONS}
                            value={product.isApproved ? 'approved' : 'notApproved'}
                            disabled={isSaving}
                            onChange={(e) => handleStatusChange(e.target.value === 'approved')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
